import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import EarningsDisplay from '../../../../../EarningsDisplay';
import FolderTypeRadioButton from '../FolderTypeRadioButton';
import { FolderType } from '../../types';
import DollarPriceInput from '../../../../../DollarPriceInput';
import s from './PremiumForm.scss';
const DEFAULT_FOLDER_PRICE = 10;
export const PremiumForm = ({ onlyNewPaidFolders , hasCoreMembership  })=>{
    const { t  } = useTranslation();
    const { control , errors , watch  } = useFormContext();
    const folderType = watch('folderType');
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, !onlyNewPaidFolders && /*#__PURE__*/ React.createElement(Controller, {
        control: control,
        name: "folderType",
        render: ({ onChange , value  })=>{
            const isSelected = (type)=>type === value;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FolderTypeRadioButton, {
                value: FolderType.REGULAR,
                title: t('mediapopup.newFolderPopup.gallery.radioButtons.regularFolder.label'),
                hint: t('mediapopup.newFolderPopup.gallery.radioButtons.regularFolder.hint'),
                onChange: onChange,
                isSelected: isSelected,
                disabled: false
            }), /*#__PURE__*/ React.createElement(FolderTypeRadioButton, {
                value: FolderType.WATCHERS,
                title: t('mediapopup.newFolderPopup.gallery.radioButtons.watchersOnly.label'),
                hint: t('mediapopup.newFolderPopup.gallery.radioButtons.watchersOnly.hint'),
                onChange: onChange,
                isSelected: isSelected,
                showCoreMembership: hasCoreMembership,
                showCoreUpgrade: !hasCoreMembership,
                disabled: !hasCoreMembership,
                biReferralType: ReferralType.PAYWALL_WATCHERS_ONLY
            }), /*#__PURE__*/ React.createElement(FolderTypeRadioButton, {
                value: FolderType.PAID,
                title: t('mediapopup.newFolderPopup.gallery.radioButtons.paid.label'),
                hint: t('mediapopup.newFolderPopup.gallery.radioButtons.paid.hint'),
                onChange: onChange,
                isSelected: isSelected,
                showCoreMembership: hasCoreMembership,
                showCoreUpgrade: !hasCoreMembership,
                disabled: !hasCoreMembership,
                biReferralType: ReferralType.PAYWALL_PG
            }));
        }
    }), folderType === 'paid' && /*#__PURE__*/ React.createElement(Controller, {
        control: control,
        name: "price",
        render: ({ onChange , value , name  })=>{
            var _errors_name;
            const placeholder = `${DEFAULT_FOLDER_PRICE}`;
            return /*#__PURE__*/ React.createElement("div", {
                className: cn(!onlyNewPaidFolders && s['premium-selected'])
            }, /*#__PURE__*/ React.createElement(DollarPriceInput, {
                className: s['price-input'],
                name: name,
                value: value,
                placeholder: placeholder,
                onChange: onChange,
                errorMessage: (_errors_name = errors[name]) === null || _errors_name === void 0 ? void 0 : _errors_name.message,
                isRequired: true
            }), /*#__PURE__*/ React.createElement(EarningsDisplay, {
                dollarPrice: value || placeholder,
                productType: "gallery"
            }));
        }
    }));
};
PremiumForm.displayName = 'PremiumForm';
export default PremiumForm;
